import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunFetchFailedAction = {
	type: 'WORKFLOW_RUN_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunFetchFailedAction => ({
	type: 'WORKFLOW_RUN_FETCH_FAILED',
	payload,
});
